export const CHANGE_TIMEZONE_OPEN_MODAL = "CHANGE_TIMEZONE_OPEN_MODAL";
export const CHANGE_TIMEZONE_CLOSE_MODAL = "CHANGE_TIMEZONE_CLOSE_MODAL";

export const CHANGE_TIMEZONE_UPDATE_REQUEST = "CHANGE_TIMEZONE_UPDATE_REQUEST";
export const CHANGE_TIMEZONE_UPDATE_RESULT = "CHANGE_TIMEZONE_UPDATE_RESULT";

export const CHANGE_TIMEZONE_SET_DEVICES = "CHANGE_TIMEZONE_SET_DEVICES";